/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-26 18:39:56
 * @Description: 检测数据推送路由
 */
const jcsjtsRoutes = {
  path: 'jcsjts',
  name: 'jcsjts',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'stsglIndex',
      component: () => import(/* webpackChunkName: "stsglIndex" */'@/features/xfjcgl/jcsjts/index.vue'),
      meta: {
        navtabTitle: '检测报告推送',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default jcsjtsRoutes;
